import { useCallback, useMemo } from 'react';

import type { EventHandlers } from '@atlaskit/editor-common/EventHandlers';

import { isExternalLink } from '@confluence/linking-platform/entry-points/isExternalLink.ts';
import {
	useMatchRoute,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState.ts';

import { createLinkEventHandler } from './createLinkEventHandler.tsx';

type ExternalLinkHandlers = {
	eventHandlers: EventHandlers | undefined;
	onSetLinkTarget: (url: string) => '_blank' | undefined;
};

/**
 * Wires external links inside deprecated macros to open in a new tab. Returns the
 * `eventHandlers` and `onSetLinkTarget` props to pass to a nested `ADFRenderer`.
 */
export const useExternalLinkHandlers = (): ExternalLinkHandlers => {
	const { push } = useRouteActions();
	const matchRoute = useMatchRoute();

	const eventHandlers = useMemo(
		() => createLinkEventHandler({ push, matchRoute }),
		[push, matchRoute],
	);

	const onSetLinkTarget = useCallback(
		(url: string) => (isExternalLink(url) ? '_blank' : undefined),
		[],
	);

	return { eventHandlers, onSetLinkTarget };
};
